module.exports = __webpack_public_path__ + "static/media/10.0cdf0475.jpg";